import { Log } from '@/types/logs'
import { CellContext } from '@tanstack/react-table'
import ChevronRightIcon from '@/modules/CombinedLogs/assets/chevron-right.svg'
import { useShareLog } from '@/modules/CombinedLogs/hooks/useShareLog'

interface Props extends Partial<CellContext<Log, unknown>> {
    handleArrowClick: (log: Log) => void
}

export const LinkToLog = ({ row, handleArrowClick }: Props) => {
    const { navToSharedLog } = useShareLog(row!.original)
    return (
        <button
            data-action
            type="button"
            onClick={() => {
                if (row!.original.routes.length === 1) {
                    navToSharedLog()
                } else {
                    handleArrowClick(row!.original)
                }
            }}
        >
            <ChevronRightIcon />
        </button>
    )
}
